declare global {
  interface Window {
    GM_STATE: {
      integrations: {
        algoliaConfig: {
          apiKey: string
          siteId: string
          indexName: string
          enable: boolean
          perPageDefault: number
          sortDefault: string
          ignoreParamsFilter: string[]
          filters: {
            key: string
            label: string
            prefix: number
            isMultiple: boolean
          }[]
        }
      },
      customer: {
        logged: boolean
        id: string
      }
      shopify: {
        shop: string,
        templateName: '404' | 'article' | 'blog' | 'cart' | 'collection' | 'list-collections' | 'customers/account' | 'customers/activate_account' | 'customers/addresses' | 'customers/login' | 'customers/order' | 'customers/register' | 'customers/reset_password' | 'gift_card' | 'index' | 'page' | 'password' | 'product' | 'search'
        templateSuffix: string
        defaultCurrency: string
        moneyFormat: string
        defaultImage?: string
        auStoreUrl?: string
        usStoreUrl?: string
        caStoreUrl?: string
        ukStoreUrl?: string
      }
    },
    collectionConfig: {
      id: string
      handle: string
      title: string
      perPage: number
      promoBanner: {
        heading: string
        subHeading: string
        image: string
        url: string
        position: number
        bannerDisable: string[]
      }
      marqueeConfig: {
        values: string[]
        row: number
        rowMobile: number
      }
      defaultLayout: string,
      hasPromoBanner: boolean
    }
    searchAlgoliaConfig: {
      topTags: string[]
      bottomTags: string[]
      popularSearched: {
        keyword: string
        position: number
      }[]
    }
    subscriptionConfig: {
      titleStep1: string
      frequencyTitle: string
      frequencyOpenModal: string
      frequencyOptions: any
      reviewSubscriptionTitle: string
      deviveryEvery: string
      costPerDelivery: string
      weeklyCost: string
      freeShipping: string
      totalCost: string
    }
  }
}

type AlgoliaConfig = {
  apiKey: string
  siteId: string
  indexName: string
  enable: boolean
  sortDefault: string
  perPageDefault: number
  ignoreParamsFilter: string[]
}

const config: AlgoliaConfig = {
  apiKey: window.GM_STATE.integrations.algoliaConfig.apiKey,
  siteId: window.GM_STATE.integrations.algoliaConfig.siteId,
  indexName: window.GM_STATE.integrations.algoliaConfig.indexName,
  enable: window.GM_STATE.integrations.algoliaConfig.enable,
  sortDefault: window.GM_STATE.integrations.algoliaConfig.sortDefault,
  perPageDefault: window.GM_STATE.integrations.algoliaConfig.perPageDefault,
  ignoreParamsFilter: window.GM_STATE.integrations.algoliaConfig.ignoreParamsFilter
}

const getBrowserCookie = (cookieName: string) => {
  if (typeof document !== 'object' || typeof document.cookie !== 'string') {
    return undefined
  }

  const name = cookieName + '='

  // Safely decode the cookie string with error handling
  let decodedCookie: string

  try {
    decodedCookie = decodeURIComponent(document.cookie)
  } catch (error) {
    // If decoding fails, use the raw cookie string
    decodedCookie = document.cookie
  }

  const ca = decodedCookie.split(';')

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]

    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }

  return undefined
}

const extractGoogleAnalyticsUserIdFromCookie = (gaCookie: string) => {
  if (gaCookie) {
    // Remove the Google Analytics tracker from the device ID.
    const userIdParts = gaCookie.split('.').slice(-2)

    if (userIdParts.length === 2) {
      return userIdParts[0]
    }
  }

  return undefined
}

const getGoogleAnalyticsUserIdFromBrowserCookie = (cookieName: string) => {
  const browserCookie = getBrowserCookie(cookieName)

  if (!browserCookie) {
    return undefined
  }

  return extractGoogleAnalyticsUserIdFromCookie(browserCookie)
}

const trackingConfig = {
  app_id: window.GM_STATE.integrations.algoliaConfig.siteId,
  search_api_key: window.GM_STATE.integrations.algoliaConfig.apiKey,
  index_name: window.GM_STATE.integrations.algoliaConfig.indexName,
  user_token: window.GM_STATE.customer?.id || getGoogleAnalyticsUserIdFromBrowserCookie('_ga') || ''
}

localStorage.setItem('algolia_config', JSON.stringify(trackingConfig))

export default config
